// will be used to test various html and css code separately from the app
import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import $ from 'jquery';
// import Clip from '../../images/clip.svg';
import './testing.css'
// import {BllinkLogger} from "../utils/bllink_loggers";
// import { constants } from "../constants/constants";

// spinner 
//https://codepen.io/SharpSeeEr/pen/BXaxgW

export class TestingComponent extends Component {


    componentDidMount() {

        $('.toast').toast('show')
    }

    render() {
        const {t} = this.props;

        return (
            <div className="container" style={{minHeight: '400px'}}>
                <div className="chk_card">
                <form className="card_from_new" _lpchecked="1" id="payment_form">
                    <div className="inner_from_Div">
                        <div className="row form-group card-visa">
                            <label>{t('card_page.card_number')} </label>
                            <input className="form-control" id="credit-card" inputMode="numeric" />

                        </div>
                    </div>
                </form>
                </div>
            </div>
        )
    }
}

export default withTranslation()(TestingComponent);

